<template>
  <div
    class="vjs-matrix front img-raised rounded img-fluid w-100 colored-shadow"
  >
    <video ref="videoPlayer" class="video-js vjs-fluid">
      <source :src="src" type="application/x-mpegURL" />
    </video>
  </div>
</template>

<script>
import videojs from "video.js";

export default {
  name: "VideoPlayer",
  props: ["title", "src", "type"],
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.player = videojs(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        console.log("onPlayerReady");
      }
    );
    //  this.player.src("https://player.vimeo.com/external/374110197.sd.mp4?s=94dc935887ddd19b3e918da6ea968c1f2d8825d0&profile_id=165")
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>
